<template>
  <div class="htcarditem" @click="tojump(hditem)">
    <div class="cove">
      <img :src="hditem.preview_pic" />
    </div>
    <div class="text">
      <div>{{ hditem.title }}</div>
      <div class="num between">
        <div class="pri">¥{{ hditem.price }}</div>
        <div class="xd">{{ hditem.download_num }}人下单</div>
      </div>
    </div>
    <div class="download">下载文档</div>
  </div>
</template>

<script>
export default {
  props: {
    hditem: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  methods: {
    tojump(item) {
      this.$router.push({
        path: "/jpcol/hdcht/conmodet",
        query: {
          hdartId: item.id,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.htcarditem {
  background: #ffffff;
  padding: 22px;
  box-shadow: 0px 1px 7px 0px rgba(0, 0, 0, 0.08);
  .cove {
    img {
      width: 240px;
      height: 300px;
    }
  }
  .text {
    margin-top: 18px;
    font-size: 16px;
    color: #323232;
    .num {
      margin-top: 16px;
      .pri {
        font-size: 14px;
        color: #da0000;
      }
      .xd {
        font-size: 14px;
        color: #969696;
      }
    }
  }
  .download {
    display: none;
    cursor: pointer;
    width: 116px;
    height: 36px;
    line-height: 36px;
    text-align: center;
    margin: 24px auto;
    background: #f25618;
    border-radius: 18px;
    font-size: 18px;
    color: #ffffff;
  }

  &:hover {
    .text {
      display: none;
    }
    .download {
      display: block;
    }
  }
}
</style>